import React from 'react';

function TabProyecto({
  projectName, setProjectName,
  projectManager, setProjectManager,
  projectUser, setProjectUser,
  propietarioEmail,
  showProjectForm, setShowProjectForm,
  isEditingProject, setIsEditingProject,
  handleSaveProject
}) {
  return (
    <div className="tab-content">
      <section className="progress-section-v2">
        {/* Header */}
        <div className="critical-header-bar">
          <span className="progress-badge" style={{ background: '#374151' }}>PROYECTO</span>
          <span className="progress-header-date">{projectName || 'Sin configurar'}</span>
        </div>

        {/* Botón para mostrar/ocultar formulario */}
        <div className="team-actions-row">
          <button
            className={`team-action-btn ${showProjectForm ? 'active-red' : 'blue'}`}
            onClick={() => setShowProjectForm(!showProjectForm)}
          >
            {showProjectForm ? 'Ocultar Datos' : '+ Configurar Proyecto'}
          </button>
        </div>

        {showProjectForm && (
          <div className="team-form-container-v2">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <div className="critical-title-row" style={{ margin: 0 }}>
                <span className="critical-square" style={{ color: '#374151' }}>■</span>
                <span className="critical-title-text">Datos del Proyecto</span>
              </div>
              {projectName && !isEditingProject && (
                <button
                  type="button"
                  className="team-action-btn amber"
                  onClick={() => setIsEditingProject(true)}
                  style={{ flex: 'none', minWidth: 'auto', padding: '6px 14px', fontSize: '12px' }}
                >
                  Editar
                </button>
              )}
            </div>
            <form className="team-form" onSubmit={handleSaveProject}>
              <input
                type="text"
                placeholder="Nombre del Proyecto"
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                className="team-input"
                disabled={!isEditingProject && projectName}
                style={{ 
                  opacity: (!isEditingProject && projectName) ? 0.7 : 1,
                  cursor: (!isEditingProject && projectName) ? 'not-allowed' : 'text'
                }}
                required
              />
              <input
                type="text"
                placeholder="Responsable/Gerente del Proyecto"
                value={projectManager}
                onChange={(e) => setProjectManager(e.target.value)}
                className="team-input"
                disabled={!isEditingProject && projectName}
                style={{ 
                  opacity: (!isEditingProject && projectName) ? 0.7 : 1,
                  cursor: (!isEditingProject && projectName) ? 'not-allowed' : 'text'
                }}
                required
              />
              <div style={{ marginBottom: '12px', width: '100%' }}>
                <label className="proyecto-field-label">
                  Email del Usuario (Correo de acceso)
                </label>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <input
                    type="email"
                    value={projectUser}
                    onChange={(e) => setProjectUser(e.target.value)}
                    className="team-input"
                    disabled={!isEditingProject}
                    style={{ 
                      opacity: !isEditingProject ? 0.7 : 1,
                      cursor: !isEditingProject ? 'not-allowed' : 'text',
                      backgroundColor: !isEditingProject ? '#f9fafb' : '#fff',
                      flex: 1
                    }}
                    title={!isEditingProject ? "Haz clic en Editar para modificar el email" : "Ingresa tu nuevo email"}
                  />
                </div>
                <small className="proyecto-field-hint">
                  {isEditingProject 
                    ? "Puedes cambiar tu email de acceso. Asegúrate de recordar el nuevo email para iniciar sesión."
                    : "Este es tu email de acceso registrado. Haz clic en Editar para modificarlo."
                  }
                </small>
              </div>
              
              <div style={{ display: 'flex', gap: '8px', marginTop: '16px', width: '100%' }}>
                <button 
                  type="submit" 
                  className="team-action-btn blue"
                  disabled={!isEditingProject && projectName}
                  style={{ 
                    flex: 1,
                    opacity: (!isEditingProject && projectName) ? 0.5 : 1,
                    cursor: (!isEditingProject && projectName) ? 'not-allowed' : 'pointer'
                  }}
                >
                  Guardar Proyecto
                </button>
                {isEditingProject && (
                  <button
                    type="button"
                    className="team-action-btn active-red"
                    style={{ flex: 'none', minWidth: 'auto' }}
                    onClick={() => {
                      setIsEditingProject(false);
                      const savedProject = localStorage.getItem('projectData');
                      if (savedProject) {
                        const project = JSON.parse(savedProject);
                        setProjectName(project.name);
                        setProjectManager(project.manager);
                        setProjectUser(project.user);
                      }
                    }}
                  >
                    Cancelar
                  </button>
                )}
              </div>
            </form>
          </div>
        )}

        {projectName && (
          <div style={{ padding: '0 24px 16px' }}>
            <div className="critical-title-row">
              <span className="critical-square" style={{ color: '#374151' }}>■</span>
              <span className="critical-title-text">Resumen del Proyecto</span>
            </div>
            <div className="proyecto-resumen-card">
              <div className="proyecto-resumen-row">
                <span className="proyecto-resumen-label">Proyecto</span>
                <span className="proyecto-resumen-value">{projectName}</span>
              </div>
              <div className="proyecto-resumen-row">
                <span className="proyecto-resumen-label">Responsable</span>
                <span className="proyecto-resumen-value">{projectManager}</span>
              </div>
              <div className="proyecto-resumen-row">
                <span className="proyecto-resumen-label">Email</span>
                <span className="proyecto-resumen-value" style={{ color: '#6b7280', fontSize: '13px' }}>{propietarioEmail || projectUser}</span>
              </div>
            </div>
          </div>
        )}

        <div style={{ padding: '0 24px 24px' }}>
          <div className="critical-title-row">
            <span className="critical-square" style={{ color: '#16a34a' }}>■</span>
            <span className="critical-title-text">Sistema de Login</span>
          </div>
          <div className="team-notif-info-box green" style={{ marginTop: '8px' }}>
            <p style={{ margin: 0, fontWeight: '700', color: '#16a34a', fontSize: '13px' }}>Sistema de autenticación activado</p>
            <p style={{ margin: '4px 0 0', color: '#374151', fontSize: '12px' }}>Las credenciales configuradas están activas. Los datos se guardan de forma segura.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TabProyecto;
